import axios from "axios";
import store from "@/store";
import { Object } from "core-js";
import servicesRoutes from "./services";
import flashMessages from '@/utils/flash-messages';

//import pkg from '../../package';

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'X-Http-Owner-Id': process.env.VUE_APP_OWNER_ID,
    // 'Access-Control-Allow-Origin': process.env.VUE_APP_API_DEVICE
  },
})

http.interceptors.request.use((config) => {
  let ownerId = config.data?.httpOwnerId;
  if (ownerId){
      config.headers['X-Http-Owner-Id'] = ownerId;
    }
  return config;
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  function(error) {
    // Lista de endpoints públicos que não devem fazer logout em caso de 401
    const publicEndpoints = [
      'updatePromoCode',
      'mailings/token',
      'mailings/firstname', // Endpoint público - não requer autenticação
      'auth/contacts',
      'auth/sanctum/token',
      'auth/generic/token' // Endpoint de login genérico - não requer autenticação
    ];
    
    const isPublicEndpoint = publicEndpoints.some(endpoint => 
      error.response?.config?.url?.includes(endpoint)
    );
    
    if ((error.response?.status === 401 || error.response?.status === 419) && !isPublicEndpoint) {
      store.dispatch("auth/ActionDoLogout");
    }

  if (error.message === 'Network Error') {
    flashMessages.error('Não foi possível se comunicar com a API');
  }

  // if (error.response?.status === 500) {
  //   flashMessages.error('Não foi possível executar a ação, tente novamente mais tarde.');
  // }
    return Promise.reject(error.response || error);
  }
);

// rotas API organizadas
let services = {};

Object.keys(servicesRoutes).map((route) => {
  services[route] = servicesRoutes[route]
});

export const auth = services.auth;
export const user = services.user;
export const cadastro = services.cadastro;
export const acordo = services.acordo;
export const erro = services.erro;
export const setBearerToken = token => {
  http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export default {
  http,
};
